export enum EmptyStateKind {
  Before = 'BEFORE',
  None = 'NONE',
  HasAvailableSites = 'HAS_AVAILABLE_SITES',
  HasNoAvailableSites = 'HAS_NO_AVAILABLE_SITES',
  HasNoRelevantProjects = 'HAS_NO_RELEVANT_PROJECTS',
  HasNoAccessibleRelevantProjects = 'HAS_NO_ACCESSIBLE_RELEVANT_PROJECTS',
  HasNoAccessibleRelevantSites = 'HAS_NO_ACCESSIBLE_RELEVANT_SITES',
}

export enum IssueCreationFailureReason {
  None = 'NONE',
  Unknown = 'UNKNOWN',
  UnsupportedFields = 'UNSUPPORTED_FIELDS',
}

export enum OnboardingViewed {
  Seen = 'SEEN',
  Unseen = 'UNSEEN',
}

export enum DevActivityKind {
  Branch = 'branch',
  // This is named 'repository' to conform to Jira's naming conventions.
  // It really represents a commit made against an issue.
  Commit = 'repository',
  PullRequest = 'pullrequest',
  Deployment = 'deployment',
}

export enum IssueCategory {
  Todo = 'new',
  InProgress = 'indeterminate',
  Done = 'done',
}

export enum IssueMigrationCurrentStep {
  Exporting = 'EXPORTING',
  Importing = 'IMPORTING',
  Finished = 'FINISHED',
  Failed = 'FAILED',
}

export const ONBOARDING_VIEWED_PREF_KEY = 'viewed-create-jira-issue-onboarding';

export const UNASSIGNED_USER_ID = 'EMPTY';
